 var Vue = require('vue')
 var VueResource = require('vue-resource')
 Vue.use(VueResource)

 var resource = Vue.resource

 var config = require('common/config')
 var apiHost = config.apiHost
 Vue.http.headers.common['Content-Type'] = 'application/json'
 Vue.http.interceptors.unshift(function (request, next) {
   next(function (response) {
     if (typeof response.headers['content-type'] !== 'undefined') {
       response.headers['Content-Type'] = response.headers['content-type']
     }
   })
 })
 module.exports = {
   $host: apiHost,
   $http: Vue.http,
   Admin: resource(apiHost + '/admin{/id}{?username}', {}, {
     resetRequest: {method: 'GET', url: apiHost + '/admin/reset{/email}'},
     resetPassword: {method: 'POST', url: apiHost + '/admin/reset'}
   }),
   User: resource(apiHost + '/user{/id}{?email}', {}, {
     profile: {method: 'GET', url: apiHost + '/profile{/username}'},
     profileByToken: {method: 'GET', url: apiHost + '/profileByToken{/token}'},
     resetRequest: {method: 'GET', url: apiHost + '/user/reset{/email}'},
     resetPassword: {method: 'POST', url: apiHost + '/user/reset'},
     verifyAccount: {method: 'PUT', url: apiHost + '/user/verify{/token}'},
     updatePassword: {method: 'PUT', url: apiHost + '/user{/id}/password'},
     findWithSubscription: {method: 'GET', url: apiHost + '/user/subscription'},
     block: {method: 'POST', url: apiHost + '/user/block'},
     unblock: {method: 'POST', url: apiHost + '/user/unblock'},
     available: {method: 'GET', url: apiHost + '/user/available{/username}{/email}'},
     validate: {method: 'POST', url: apiHost + '/user/validate'},
     createWithMessage: {method: 'POST', url: apiHost + '/user/createWithMessage'},
     reSendDelayedVerification: {method: 'POST', url: apiHost + '/user/reSendDelayedVerification'},
     createPaymentUrl: {method: 'POST', url: apiHost + '/user/createPaymentUrl'},
     suggestUsername: {method: 'GET', url: apiHost + '/user/suggest{/username}'},
     findWithHistory: {method: 'GET', url: apiHost + '/user{/id}/history'}
   }),
   Label: resource(apiHost + '/label{/lang}{/type}', {}, {
     bulkUpdate: {method: 'PUT', url: apiHost + '/label'}
   }),
   Lookup: resource(apiHost + '/lookup'),
   Menu: resource(apiHost + '/menu'),
   Lang: resource(apiHost + '/lang{/code}'),
   AppConfig: resource(apiHost + '/config/findConfig', {}, {
     save: {method: 'PUT', url: apiHost + '/config'}
   }),
   Service: resource(apiHost + '/service{/code}', {}, {
     check: {method: 'GET', url: apiHost + '/service/check{/code}'}
   }),
   BillingPeriod: resource(apiHost + '/billingPeriod{/service}', {}, {
     bulkUpdate: {method: 'PUT', url: apiHost + '/billingPeriod'}
   }),
   UrlAction: resource(apiHost + '/urlAction{/token}', {}, {
     invalidate: {method: 'PUT', url: apiHost + '/invalidate{/token}'}
   }),
   Delay: resource(apiHost + '/delay{/token}'),
   SendConfirmation: resource(apiHost + '/sendConfirmation/token{/token}', {}, {
     send: {method: 'GET', url: apiHost + '/sendConfirmation/user{/userId}{/service}'}
   }),
   Message: resource(apiHost + '/message{/id}', {}, {
     deleteAll: {method: 'DELETE', url: apiHost + '/messages{/userId}'}
   }),
   MessageModel: resource(apiHost + '/messageModel{/id}'),
   File: resource(apiHost + '/file{/key}/{id}', {}, {
     getLink: {method: 'GET', url: apiHost + '/file{/token}'}
   }),
   Subscription: resource(apiHost + '/subscription{/id}'),
   SendSMS: resource(apiHost + '/sms/send', {}, {
     send: {method: 'POST', url: apiHost + '/sms/send'},
     clientTest: {method: 'POST', url: apiHost + '/sms/clientTest'}
   })
 }



// WEBPACK FOOTER //
// ./src/api/index.js